export default __webpack_public_path__ + "static/media/image6.1f80b3de.png";